import { render, staticRenderFns } from "./TabellaPezzi.vue?vue&type=template&id=d7469bde&"
import script from "./TabellaPezzi.vue?vue&type=script&lang=js&"
export * from "./TabellaPezzi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports